import { observer } from 'mobx-react';
import moment from 'moment';
import _ from 'lodash';

import { ApiMixin } from "../ApiMixin";
import { AppUserApi } from "../../../util/api/ServiceObjects/AppUserApi";

//Returns the student object, plus some helper functions
class AppUser {
    userName : null; //= principal.Claims.ElementAt(0).Value,
    isAdmin : false; 
    accountIds : [];
    studentId : null;

    constructor(user = {}) {
        _.defaults(this, user);

        ApiMixin(this, AppUserApi);
    }

    mutate(user) {

        //This takes all matching keys from the user and assigns them to this object

        _.assign(this, _.pick(user, _.keys(this)));

    }
}

//observer(Timestamp);

export default AppUser;
